import React from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { EnumUserType } from "../../interfaces/userData.interface";
import enquiryscss from "../../sass/enquiry-list/Enquiry.module.scss";
import { useAppSelector } from "../../store";

export const CrmMenuBar = () => {
  const userData = useAppSelector((store) => store.users.userData);
  const userType = userData?.userType;
  return (
    <>
      <div className="container">
        {userType === EnumUserType.STAFF && (
          <div className="row justify-content-between align-items-center my-2">
            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
              <div>
                <Link className=" btn btn-sm back-btn" to={"/"}>
                  <i className="fa-solid fa-chevron-left me-2"></i>
                  Go to list
                </Link>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-12 small">
              <div className={enquiryscss.crmMenuButtonContainer}>
                <Dropdown className="">
                  <Dropdown.Toggle
                    variant="primary"
                    className="w-100 border rounded crm-menu-button"
                    id="dropdown-basic"
                  >
                    <span className="me-1">Crm Menu</span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="w-100 text-center">
                    <Dropdown.Item as={Link} to="dashboard">
                      Dashboard
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="department">
                      Departments
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="deskphone">
                      Deskphone
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="department-config">
                      Department Staff Config
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        )}
      </div>
      <hr className="m-0"></hr>
    </>
  );
};
